import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { AdminsAvatarsComponent, type AvatarUser } from '@core/account-ui';
import type { TaskData } from '@core/tellent-assistant-types';
import { CheckboxComponent } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';

@Component({
  selector: 'rt-list-item-task',
  imports: [ListCardComponent, CheckboxComponent, AdminsAvatarsComponent, MomentModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-task.component.html',
  styleUrl: './list-item-task.component.less',
})
export class ListItemTaskComponent {
  protected readonly avatarUsers = computed<AvatarUser[]>(
    () =>
      this.data().admins?.map((admin, index) => ({
        id: index,
        name: admin.name,
        initials: admin.initials ?? '',
        photoThumbUrl: admin.avatarUrl ?? '',
        hasAvatar: !!admin.avatarUrl,
      })) ?? [],
  );

  public readonly data = input.required<TaskData>();
}
